/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sound_Sharp_Salmon_EarnInputs */

const fr_sound_sharp_salmon_earn = /** @type {(inputs: Sound_Sharp_Salmon_EarnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle catégorie`)
};

/**

* @param {Sound_Sharp_Salmon_EarnInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sound_sharp_salmon_earn = /** @type {((inputs?: Sound_Sharp_Salmon_EarnInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sound_Sharp_Salmon_EarnInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sound_sharp_salmon_earn(inputs)
});